import React, { useContext } from 'react';

import { RicosContext } from './../../../ricos-context';

import type { LayoutProps } from '../common-types';
import { FullscreenMobileLayout } from '../fullscreen-mobile-layout/fullscreen-mobile-layout';
import { FloatingDesktopLayout } from './floating-desktop-layout';

export const FloatingLayout: React.FC<LayoutProps> = props => {
  const { isMobile } = useContext(RicosContext);
  const Layout = isMobile ? FullscreenMobileLayout : FloatingDesktopLayout;
  return <Layout {...props} />;
};
